import { Feature } from '../../../models/features';
import { SharedState } from '../reducer';

export const sharedSelector = state => state[Feature.SHARED] as SharedState;
